import { CloseFilled } from '@icon';
import React from 'react';
import { useTheme } from 'styled-components';
import Form from '../../../../../../../form';
import { TFormVariant } from '../../../../../../../form/Form.types';
import { ClearIconSC, InputSeparator } from './clear-icon.styled';

interface ClearIconProps
  extends Omit<
    React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>,
    'children'
  > {
  variant?: TFormVariant;
  hasSibling?: boolean;
}

const ClearIcon: React.FunctionComponent<ClearIconProps> = ({
  variant,
  hasSibling,
  ref,
  ...rest
}) => {
  const theme = useTheme();
  const settings = Form.useFormSettings({ variant });

  return (
    <ClearIconSC tabIndex={-1} {...rest}>
      <CloseFilled
        width={20}
        height={20}
        color={
          settings.variant === 'on-dark' ? theme.color.tint.tertiaryDark : theme.color.tint.tertiary
        }
      />
      {hasSibling ? (
        <InputSeparator
          style={{
            borderRightColor:
              settings.variant === 'on-dark'
                ? theme.color.border.emphasisDark
                : theme.color.border.emphasis,
          }}
        />
      ) : null}
    </ClearIconSC>
  );
};

export default ClearIcon;
